import { useDispatch as useDispatchBase } from 'react-redux'
import { useMemo } from 'react'
import { bindActionCreators } from 'redux'

const useDispatch = (actions, deps) => {
  const dispatch = useDispatchBase()
  return useMemo(() => {
    if (!actions) {
      return dispatch
    }
    if (Array.isArray(actions)) {
      return actions.map(a => bindActionCreators(a, dispatch))
    }
    return bindActionCreators(actions, dispatch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps ? [dispatch, ...deps] : [dispatch])
}

export {
  useDispatch
}



// WEBPACK FOOTER //
// ./src/hooks/dispatch.js